var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showBanner
    ? _c(
        "div",
        { staticClass: "banner", attrs: { id: "switch-to-old-banner" } },
        [
          _c(
            "div",
            { staticClass: "container flex flex-wrap flex-md-nowrap" },
            [
              _vm._m(0),
              _vm._v(" "),
              _c("span", { staticClass: "flex justify-between mt-2 mt-md-0" }, [
                _c(
                  "a",
                  {
                    staticClass: "btn btn-secondary btn-sm",
                    attrs: {
                      id: "close-banner-accept",
                      href: "#",
                      role: "button",
                      "aria-label": "Close banner",
                    },
                    on: { click: _vm.cookieAccept },
                  },
                  [
                    _c(
                      "span",
                      [
                        _c("font-awesome-icon", {
                          attrs: {
                            icon: "fa-solid fa-check",
                            "aria-hidden": "true",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(
                      "\n                I'm fine with this\n            "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "btn btn-secondary btn-sm",
                    attrs: {
                      id: "close-banner-reject",
                      href: "#",
                      role: "button",
                      "aria-label": "Close banner",
                    },
                    on: { click: _vm.cookieReject },
                  },
                  [
                    _c(
                      "span",
                      [
                        _c("font-awesome-icon", {
                          attrs: {
                            icon: "fa-solid fa-xmark",
                            "aria-hidden": "true",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(
                      "\n                Reject non-essential cookies\n            "
                    ),
                  ]
                ),
              ]),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c("strong", [
        _c("a", { attrs: { href: "/cookies" } }, [
          _vm._v(
            "\n                    This site uses cookies.\n                "
          ),
        ]),
      ]),
      _vm._v(
        "\n            Some are necessary for core functionality but others are used for analytics and measuring campaign performance.\n        "
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }